<div class="thankyou">
  <img src="/assets/img/thankyou.jpg">
<nz-result
      nzStatus="success"
      nzTitle="Cảm ơn bạn đã tham gia khảo sát!"
    >
      <div nz-result-extra>
        <button nz-button [routerLink]="['/', id === '1' ? 'phieuhoinkt' : 'phieuhoigv']">Quay lại</button>
      </div>
</nz-result>
</div>
